/* Calimia custom nav behaviour. Moved out of snippets/mega-menu.liquid on 2026-09-25
   (~9KB inlined into every page). Loaded with defer; the IIFE already guards its own
   start with a readyState check plus a MutationObserver, so running after parse is
   the same behaviour it had inline. Pure JS, no Liquid - keep it that way. */
  (function(){
    var subnavStack=null,timer=null,prefetched={};

    /* WHERE "VISIT US" GOES. 2026-09-23: repointed to the new /pages/visit-us page, which holds
       the showroom photo, address, hours, phone, email, a Get Directions button and the map.
       It is INTERNAL now, so no target/rel - it used to open the Google Maps listing in a new
       tab. The desktop link here, the mobile menu item and the footer "Visit Us" link all point
       at the page. TWO PLACES DELIBERATELY STILL USE THE MAPS LISTING, because they are meant to
       be directions rather than a page: "Visit the showroom" on the paint PDP (cta2_url in
       'templates/product.farrowball.json') and the footer ADDRESS LINE (the VISIT US text block
       in 'sections/footer-group.json'). Do not sweep those two into the page by accident. */
    var VISIT_URL='/pages/visit-us';

    function src(){ return document.getElementById('cshop-subnav-src'); }
    function toolbar(){ return document.querySelector('.collection-toolbar'); }
    function placedSubnav(){
      var bar=toolbar();
      var n=bar&&bar.nextElementSibling;
      return n&&n.classList&&n.classList.contains('csubnav')?n:null;
    }

    /* CROSS-LISTING. 'collection-subnav' renders one .cshop-cand per column that contains this
       collection. Liquid cannot read the query string, so the choice is made here: ?from= names
       a parent handle, and without it we take the block marked data-default. Everything the
       page needs to dress itself as that parent hangs off the chosen block. */
    function candidate(){
      var s=src();
      if(!s)return null;
      var cands=s.querySelectorAll('.cshop-cand');
      if(!cands.length)return null;
      var from=null;
      try{ from=new URLSearchParams(location.search).get('from'); }catch(e){}
      if(from){
        for(var i=0;i<cands.length;i++){
          if(cands[i].getAttribute('data-parent')===from)return cands[i];
        }
      }
      return s.querySelector('.cshop-cand[data-default="1"]')||cands[0];
    }

    function drawerOffset(){
      var hdr=document.querySelector('x-header.header')||document.querySelector('.header');
      if(!hdr)return;
      var b=Math.max(0,Math.round(hdr.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--cshop-drawer-top',b+'px');
    }
    function injRight(){
      var ul=document.querySelector('.header__secondary-nav ul');
      if(!ul||ul.querySelector('.cshop-visit'))return;
      var li=document.createElement('li');li.className='cshop-visit';
      var a=document.createElement('a');
      a.href=VISIT_URL;
      a.textContent='Visit Us';
      li.appendChild(a);ul.insertBefore(li,ul.firstChild);
    }
    function injLeft(){
      var h=document.querySelector('x-header.header')||document.querySelector('.header');
      if(!h||h.querySelector('.cshop-left'))return;
      var nav=document.createElement('nav');nav.className='cshop-left';
      [['Studio','/pages/studio'],['Projects','/pages/projects'],['Inquire','/pages/inquire'],['Cabinetry','/pages/cabinetry']].forEach(function(l){
        var a=document.createElement('a');a.textContent=l[0];a.href=l[1];nav.appendChild(a);
      });
      h.insertBefore(nav,h.firstChild);
    }
    function injFooter(){
      var f=document.querySelector('#sidebar-menu .header-sidebar__footer');
      if(!f||f.querySelector('.cshop-fbar'))return;
      var s=document.getElementById('cshop-foot-src');
      if(!s)return;
      var bar=s.querySelector('.cshop-fbar');
      var soc=s.querySelector('.cshop-social');
      var prev=f.querySelector('a[href*="customer_authentication"], a[href*="/account"]');
      if(bar){
        if(prev){var lg=bar.querySelector('.cshop-fbar__login'); if(lg) lg.setAttribute('href', prev.getAttribute('href'));}
        f.appendChild(bar);
      }
      if(soc) f.appendChild(soc);
    }

    /* Title BUILT in the bar, never moved into it. The banner section's own h1 is hidden by CSS
       (.ctitle__text) so it cannot paint in the wrong place and then jump - that move was a
       visible reflow on every page load. Rebuilding also covers the section re-render case,
       where the server node no longer exists. */
    function injTitle(){
      var bar=toolbar();
      if(!bar||bar.querySelector('.cshop-ctitle'))return;
      var c=candidate();
      var t='';
      if(c){
        if(c.getAttribute('data-title-only')!=='1')return;
        t=c.getAttribute('data-title')||'';
      }else{
        /* No candidate: the collection is not in the shop menu (a sale event, a vendor page).
           'collection-banner.liquid' still renders the compact .ctitle block with its hidden
           h1, so take the title from there and build it into the bar the same way. */
        var own=document.querySelector('.ctitle__text .h1');
        if(own)t=own.textContent.trim();
      }
      if(!t)return;
      var node=document.createElement('h1');
      node.className='h1 cshop-ctitle';
      node.textContent=t;
      bar.insertBefore(node,bar.querySelector('.collection-toolbar__products-count')||null);
      /* One H1 per page (2026-09-15): the hidden server h1 in .ctitle__text has done its no-JS and
         crawler job, so demote it to <p class="h1"> now that the toolbar copy exists. The fallback
         above reads .ctitle__text .h1 so a re-run after a section swap still finds the title. */
      var src=document.querySelector('.ctitle__text h1');
      if(src){var p=document.createElement('p');p.className=src.className;p.textContent=src.textContent;src.parentNode.replaceChild(p,src);}
    }

    /* The breadcrumb is rendered by 'collection-banner.liquid', which resolves its parent in
       Liquid and so cannot see ?from=. Rewrite its last crumb from the chosen candidate, or a
       cross-listed page would read 'Outdoor' in the crumb and 'Decor' in the heading. */
    function injCrumb(){
      var c=candidate();
      if(!c||c.getAttribute('data-title-only')!=='1')return;
      var items=document.querySelectorAll('.breadcrumb__list-item');
      if(!items.length)return;
      var a=items[items.length-1].querySelector('a');
      if(!a)return;
      var t=c.getAttribute('data-title')||'';
      var u=c.getAttribute('data-parent-url')||'';
      if(t&&a.textContent.trim()!==t)a.textContent=t;
      if(u&&a.getAttribute('href')!==u)a.setAttribute('href',u);
    }

    function subnavPull(){
      var nav=placedSubnav();
      if(!nav||!subnavStack)return;
      var g=parseFloat(getComputedStyle(subnavStack).rowGap);
      if(!isFinite(g))g=0;
      nav.style.marginTop=(-g)+'px';
    }

    /* Which pill is current, decided from the URL. Liquid cannot: the row renders in the header,
       where `current_tags` is empty. Query strings are stripped from both sides so a ?from=
       link still matches the page it points at. */
    function markActive(nav){
      if(!nav)return;
      var path=location.pathname.replace(/\/+$/,'');
      var links=nav.querySelectorAll('.csubnav__link');
      var hit=null;
      for(var i=0;i<links.length;i++){
        var href=(links[i].getAttribute('href')||'').split('?')[0].replace(/\/+$/,'');
        links[i].classList.remove('is-active');
        links[i].removeAttribute('aria-current');
        if(href===path)hit=links[i];
      }
      if(hit){hit.classList.add('is-active');hit.setAttribute('aria-current','page');}
    }

    /* Each pill is a real navigation. Prefetch on hover / touchstart so the document is already
       cached when the click lands - this is what stops it feeling like a hard reload. */
    function prefetch(url){
      if(!url||prefetched[url])return;
      prefetched[url]=1;
      var l=document.createElement('link');
      l.rel='prefetch';l.href=url;l.as='document';
      document.head.appendChild(l);
    }
    function armPrefetch(nav){
      if(!nav||nav.dataset.cshopPrefetch)return;
      nav.dataset.cshopPrefetch='1';
      var arm=function(e){
        var a=e.target.closest&&e.target.closest('.csubnav__link');
        if(a)prefetch(a.getAttribute('href'));
      };
      nav.addEventListener('mouseover',arm,{passive:true});
      nav.addEventListener('touchstart',arm,{passive:true});
    }

    function injSubnav(){
      if(placedSubnav())return;
      var c=candidate();
      if(!c)return;
      var tpl=c.querySelector('.csubnav');
      if(!tpl)return;
      var bar=toolbar();
      if(!bar||!bar.parentNode)return;
      bar.parentNode.insertBefore(tpl.cloneNode(true),bar.nextSibling);
      subnavStack=bar.parentNode;
      subnavPull();
    }

    function run(){
      injLeft();injRight();injFooter();injTitle();injCrumb();injSubnav();
      var nav=placedSubnav();
      markActive(nav);armPrefetch(nav);
      drawerOffset();
    }

    /* setTimeout, not requestAnimationFrame - rAF is paused while the page is not rendering. */
    function schedule(){
      if(timer)return;
      timer=setTimeout(function(){timer=null;run();},0);
    }

    if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);

    if(window.MutationObserver){
      var mo=new MutationObserver(function(){
        var bar=toolbar();
        if(!bar)return;
        if(!bar.querySelector('.cshop-ctitle')||!placedSubnav())schedule();
      });
      var start=function(){ mo.observe(document.body,{childList:true,subtree:true}); };
      if(document.body)start();else document.addEventListener('DOMContentLoaded',start);
    }

    addEventListener('scroll',drawerOffset,{passive:true});
    addEventListener('resize',function(){drawerOffset();subnavPull();});
  })();
